class InstitutionSingle {
	constructor() {
		this.handleModalVisibility();
		this.handleOpeningHours();
		this.handleViewBannerImage();
		this.handleScrollCarousel('institution-communities', 'institution-communities-left', 'institution-communities-right');
		this.handleScrollCarousel('institution-chapels', 'institution-chapels-left', 'institution-chapels-right');
	}

	handleScrollCarousel(listId, prevId, nextId) {
		const list = document.getElementById(listId);
		const prevButton = document.getElementById(prevId);
		const nextButton = document.getElementById(nextId);

		if (!list || !prevButton || !nextButton) {
			return;
		}

		const scrollAmount = 240;

		prevButton.addEventListener('click', () => {
			list.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
		});

		nextButton.addEventListener('click', () => {
			list.scrollBy({ left: scrollAmount, behavior: 'smooth' });
		});
	}

	handleViewBannerImage() {
		const button = document.querySelector('#view-institution-banner-image');

		if (button) {
			button.addEventListener('click', () => {
				const imageSrc = document.querySelector('#institution-photo-field img').src;
				const imageAlt = document.querySelector('#institution-photo-field img').alt;
				const modalHtml = `
					<div id="wp-parresia-register-single-banner-popup" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
						<div class="relative bg-white overflow-hidden max-w-4xl mx-4">
							<span id="wp-parresia-register-single-banner-popup-close" class="absolute z-10 top-5 right-5 !text-white cursor-pointer bg-black bg-opacity-30 rounded-md p-1 hover:bg-opacity-50 focus:outline-none">
								<svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
									<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
								</svg>
							</span>
							<div class="overflow-hidden relative bg-white p-4">
								<img src="${imageSrc}" alt="${imageAlt}" class="h-auto object-fill !rounded-none">
							</div>
						</div>
					</div>
				`;

				document.body.insertAdjacentHTML('beforeend', modalHtml);

				const modal = document.querySelector('#wp-parresia-register-single-banner-popup');
				const closeBtn = document.querySelector('#wp-parresia-register-single-banner-popup-close');

				closeBtn.addEventListener('click', () => {
					modal.remove();
				});

				modal.addEventListener('click', (e) => {
					if (e.target === modal) {
						modal.remove();
					}
				});
			});
		}
	}
	handleOpeningHours() {
		const horary = document.querySelector('#institution-organisms-section-opening-hours');
		const horaryList = document.querySelector('#institution-organisms-section-opening-hours-list');
		if (horary) {
			horary.addEventListener('click', () => {
				horaryList.classList.toggle('hidden');
			});
		}
	}

	handleModalVisibility() {
		const modal = document.querySelector("#wp-parresia-register-single-horary-popup");
		const triggers = document.querySelectorAll("#wp-parresia-register-single-horarys .wp-parresia-register-single-horary");
		const close = document.querySelector("#wp-parresia-register-single-horary-popup-close");

		triggers.forEach(trigger => {
			trigger.addEventListener('click', () => this.openModal(modal, trigger));
		});

		if (close) {
			close.addEventListener('click', () => this.closeModal(modal));
		}

		document.addEventListener('click', (e) => {
			if (e.target === modal) {
				this.closeModal(modal)
			}
		})
	}

	openModal(modal, trigger) {
		modal.classList.remove('hidden');
		const data = JSON.parse(trigger.getAttribute('data-item'));

		if (data) {
			this.fillModal(data);
		}
	}

	closeModal(modal) {
		modal.classList.add('hidden')
	}

	fillModal(data) {
		const name = document.querySelector('#wp-parresia-register-single-horary-popup-name');
		const recurrence = document.querySelector('#wp-parresia-register-single-horary-popup-recurrence');
		const weekdays = document.querySelector('#wp-parresia-register-single-horary-popup-weekdays');
		const schedules = document.querySelector('#wp-parresia-register-single-horary-popup-schedules');

		name.innerHTML = data.name;
		recurrence.innerHTML = data.line_recurrence;
		weekdays.innerHTML = data.line_weekdays;
		schedules.innerHTML = this.buildScheduleList(data.schedules) + ` - ${data.description}`;
	}

	buildScheduleList(schedules) {
		const formattedSchedules = [];

		schedules.forEach(schedule => {
			let scheduleString = '';
			if (schedule.hour) {
				scheduleString += schedule.hour;
			}

			if (schedule.celebrant_name && schedule.celebrant_name !== undefined) {
				if (scheduleString) {
					scheduleString += ` - ${schedule.celebrant_name}`;
				} else {
					scheduleString += schedule.celebrant_name;
				}
			}
			if (scheduleString) {
				formattedSchedules.push(scheduleString);
			}
		});

		return formattedSchedules.join(' / ');
	}
}

document.addEventListener('DOMContentLoaded', () => {
	new InstitutionSingle();
});
